"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.argDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var argDependencies = exports.argDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createArg: _factoriesAny.createArg
};